import { loadingAtom } from '@/atoms/loadingAtom';
import { Logo } from '@/components/Logo';
import { ResetLink } from '@/components/ResetLink';
import { useCreateHref } from '@/utils/createHref';
import { useAtomValue } from 'jotai';
import { motion } from 'motion/react';
import Image from 'next/image';

interface HeroProps {
  compact?: boolean;
  loading?: boolean;
}

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut',
    },
  },
};

export function Hero({ compact }: HeroProps) {
  const loading = useAtomValue(loadingAtom);
  const getHref = useCreateHref();
  const href = getHref('/');
  const compactClass = compact ? 'items-start' : 'items-center';
  const araClass = `text-4xl transform font-bold text-center bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600`;
  const rugClass = `text-gray-300 text-center max-w-2xl ${compact ? 'text-xl' : 'text-lg'}`;
  const sizeClass = compact ? 125 : 230;

  return (
    <div className="w-full">
      <div className={`flex flex-col md:flex-row w-full ${compactClass} justify-center`}>
        <motion.div
          variants={itemVariants}
          className={`flex ${compact ? 'flex-row' : 'flex-col'} justify-center items-center ${compact ? 'gap-4' : 'space-y-4'} md:w-full`}
          viewport={{ once: true }}
        >
          <ResetLink href={href}>
            {loading ? (
              <Image
                src="/logo_loading.gif"
                alt="Loading Logo"
                width={sizeClass}
                height={sizeClass}
                className="drop-shadow-lg"
                priority
              />
            ) : (
              <Logo width={sizeClass} height={sizeClass} className="drop-shadow-lg" />
            )}
          </ResetLink>

          <div className={`flex flex-col ${compact ? 'items-start' : 'items-center'}`}>
            <ResetLink href={href}>
              <h1 className={araClass}>Anti Rug Agent</h1>
              <p className={rugClass}>Rugs shall not pass.</p>
            </ResetLink>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
